import React, { Component } from 'react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Popper from '@mui/material/Popper';
import Paper from '@mui/material/Paper';

import s from './WithPopover.css';

export default class WithPopover extends Component {
  state = {
    arrowRef: null,
  };

  setArrowRef = node => this.setState({ arrowRef: node });

  render() {
    const { children, anchor, setAnchor, popover, arrowStyle, hideArrow } = this.props;
    const { arrowRef } = this.state;
    return (
      <>
        {children}

        <Popper
          className={s.arrowPopper}
          open={Boolean(anchor)}
          anchorEl={anchor}
          anchorReference="anchorEl"
          onClose={() => setAnchor(null)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          popperOptions={{
            modifiers: {
              arrow: {
                enabled: Boolean(arrowRef),
                element: arrowRef,
              },
            },
          }}
          style={{ zIndex: 9999 }}
        >
          <ClickAwayListener
            onClickAway={e => {
              e.preventDefault();
              e.stopPropagation();
              setAnchor(null);
            }}
          >
            <div>
              {!hideArrow && (
                <span
                  className={s.arrowArrow}
                  style={arrowStyle}
                  ref={this.setArrowRef}
                />
              )}
              <Paper className={s.paper}>{popover}</Paper>
            </div>
          </ClickAwayListener>
        </Popper>
      </>
    );
  }
}
